import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router";
import ProtectedRoute from "./ProtectedRoute";
import ProtectedPortalRoute from "./ProtectedPortalRoute";
import PermissionProtectedRoute from "./PermissionProtectedRoute";
import Login from "@screens/login/Login";
import LoginVerification from "@screens/login/LoginVerification";
//import PortalRedirection from "@screens/portal-redirection/PortalRedirection";
import Layout from "../Layout";
import { ROUTES } from "./RouteConstant";
import ClientServicePortal from "@screens/client-service-portal/ClientServicePortal";

const Dashboard = React.lazy(() => import("@screens/dashboard/Dashboard"));
const CompanyManagement = React.lazy(
  () => import("@screens/company-management/CompanyManagement")
);
// const ServiceManagement = React.lazy(
//   () => import("@screens/service-management/ServiceManagement")
// );
const ProductManagement = React.lazy(
  () => import("@screens/product-management/ProductManagement")
);
const UserGroup = React.lazy(() => import("@screens/user-group/UserGroup"));
const UserGroupAdd = React.lazy(
  () => import("@screens/user-group/UserGroupAdd")
);
const UserManagement = React.lazy(
  () => import("@screens/user-management/UserManagement")
);

interface ProtectedPermissionRouteProps {
  endpointCodes: string[];
  Component: React.FC;
}

const LoaderFallback = () => (
  <div className="overlay-loader" role="status" aria-label="Loading">
    <div className="spinner" aria-hidden="true"></div>
  </div>
);

const ProtectedPermissionRoute: React.FC<ProtectedPermissionRouteProps> = ({
  endpointCodes,
  Component,
}) => {
  return endpointCodes.length > 0 ? (
    <ProtectedRoute>
      <PermissionProtectedRoute endpointCodes={endpointCodes}>
        <Suspense fallback={<LoaderFallback />}>
          <Component />
        </Suspense>
      </PermissionProtectedRoute>
    </ProtectedRoute>
  ) : (
    <ProtectedRoute>
      <Suspense fallback={<LoaderFallback />}>
        <Component />
      </Suspense>
    </ProtectedRoute>
  );
};

const AppRouter = () => {
  return (
    <Routes>
      <Route path={ROUTES.LOGIN} element={<Login />} />
      <Route path={ROUTES.TOKEN_VERIFICATION} element={<LoginVerification />} />

      {/* <Route
        path={ROUTES.PORTAL_REDIRECTION}
        element={
          <ProtectedPortalRoute>
            <PortalRedirection />
          </ProtectedPortalRoute>
        }
      /> */}
      <Route
        path={ROUTES.PORTAL_REDIRECTION}
        element={
          <ProtectedPortalRoute>
            <ClientServicePortal />
          </ProtectedPortalRoute>
        }
      />
      <Route path="/" element={<Navigate to={ROUTES.DASHBOARD} replace />} />

      <Route path="/" element={<Layout />}>
        <Route
          path={ROUTES.DASHBOARD}
          element={
            <ProtectedPermissionRoute
              endpointCodes={[]}
              Component={Dashboard}
            />
          }
        />
        <Route
          path={ROUTES.COMPANY_MANAGEMENT}
          element={
            <ProtectedPermissionRoute
              endpointCodes={["GETALLCOMPANY"]}
              Component={CompanyManagement}
            />
          }
        />
        {/* <Route
          path={ROUTES.SERVICE_MANAGEMENT}
          element={
            <ProtectedPermissionRoute
              endpointCodes={[]}
              Component={ServiceManagement}
            />
          }
        /> */}
        <Route
          path={ROUTES.PRODUCT_MANAGEMENT}
          element={
            <ProtectedPermissionRoute
              endpointCodes={["GETALLSERVICE", "GETALLSERVICEENDPOINT"]}
              Component={ProductManagement}
            />
          }
        />
        <Route
          path={ROUTES.USER_GROUP}
          element={
            <ProtectedPermissionRoute
              endpointCodes={["GETALLUSERGROUP"]}
              Component={UserGroup}
            />
          }
        />
        <Route
          path={ROUTES.USER_GROUP_ADD}
          element={
            <ProtectedPermissionRoute
              endpointCodes={["ADDUSERGROUP"]}
              Component={UserGroupAdd}
            />
          }
        />
        <Route
          path={ROUTES.USER_GROUP_EDIT}
          element={
            <ProtectedPermissionRoute
              endpointCodes={["UPDATEUSERGROUP"]}
              Component={UserGroupAdd}
            />
          }
        />
        <Route
          path={ROUTES.USERS}
          element={
            <ProtectedPermissionRoute
              endpointCodes={["GETALLUSER"]}
              Component={UserManagement}
            />
          }
        />
      </Route>
    </Routes>
  );
};

export default AppRouter;
